<button
  mat-button
  class="factoryOption mat-badge mat-menu-trigger mat-button mat-button-base mat-badge-overlap mat-badge-above mat-badge-after mat-badge-medium"
>
  <!-- <app-svg name="alarm" class="factorySelection" 
        routerLink="/alarmas">
    </app-svg> -->
  <span
    class="material-icons main-alarm"
    style="color: rgb(255, 102, 0); border:1"
    routerLink="/alarmas"
    title="{{ 'ALARMAS.ALARMAS_BADGE.all' | translate }}"
  >
    report_problem
  </span>
  <span
    id="mat-badge-content-alarma-alarmed"
    class="mat-badge-content mat-badge mat-badge-active alarmas-alarmed"
    title="{{ 'ALARMAS.ALARMAS_BADGE.alarmed' | translate }}"
    (click)="goAlarmed()"
  >
    {{ AlarmedCounter }}
  </span>
  <span
    id="mat-badge-content-alarma-subscribed"
    class="mat-badge-content mat-badge mat-badge-active alarmas-subscribed"
    (click)="goSubscribed()"
    title="{{ 'ALARMAS.ALARMAS_BADGE.subscribed' | translate }}"
  >
    {{ SubscribedCounter }}
  </span>
  <span
    id="mat-badge-content-alarma-active"
    class="mat-badge-content mat-badge mat-badge-active alarmas-active"
    title="{{ 'ALARMAS.ALARMAS_BADGE.actived' | translate }}"
    (click)="goActive()"
  >
    {{ ActiveCounter }}
  </span>
</button>
